<template>
  <BreadCrumb PageTitle="Colis Erronés" />
  <ColisErrones />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ColisErrones from "@/components/Generals/Stores/ColisErrones.vue";

export default defineComponent({
  name: "ColisErronesPage",
  components: {
    BreadCrumb,
    ColisErrones,
  },
});
</script>